import { useTranslation } from "react-i18next";
import MScreen from "../../../components/pos/MScreen";
import DoneIcon from "@mui/icons-material/Done";

import { useEffect, useState } from "react";
import { Grid } from "@mui/material";

import API from "../../../utils/API";
import db from "../../../db/db";
export default function MSync(props, ref) {
  const { t, i18n } = useTranslation();
  const translate = t;

  const [uploadCount, setUploadCount] = useState(0);
  const [downloadCount, setDownloadCount] = useState("");

  useEffect(() => {
    checkSyncStatus();
  }, []);

  async function checkSyncStatus() {
    let syncMeta = await db.sync_meta.count();
    setUploadCount(syncMeta);

    let dbData = await db.table("sync_head").get("lastRef");
    try {
      setDownloadCount("Checking");
      let { data } = await API.get("/api/v1/sync/pullRef/" + dbData.value);
      setDownloadCount(data.transactions.length);
    } catch (err) {
      setDownloadCount("Offline");
    }
  }

  return (
    <MScreen
      title={translate("Sync Status")}
      isMoreMenuEnabled={false}
      onRedirectToBack={() => props.setCurrentScreen("home")}
      rightAction={translate("OK")}
      onRightAction={() => {
        props.setCurrentScreen("home");
      }}
      rightActionIcon={<DoneIcon></DoneIcon>}
      enbaleRightAction={true}
      onLogOut={props.onLogOut}
      content={
        <div style={{ marginTop: 10 }}>
          <Grid container>
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("Upload Count")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {uploadCount}
            </Grid>{" "}
            <Grid item xs={6} sx={{ border: 1 }}>
              {translate("Download")}
            </Grid>
            <Grid item xs={6} sx={{ border: 1 }}>
              {downloadCount}
            </Grid>
          </Grid>
        </div>
      }
    ></MScreen>
  );
}
